<template>
  <q-page>
    <div class="row q-px-md q-py-lg">
      <q-btn
        icon="arrow_back"
        flat
        round
        color="indigo-6"
        label="Back"
        no-caps
        class="pc-semibold"
        to="/"
      />
    </div>
    <div class="text-subtitle2 pc-bold text-grey-9 text-center q-mb-lg">
      {{ selectedPass.name }}
    </div>
    <q-icon
      :name="selectedPass.service"
      class="text-center full-width text-indigo-6 q-mb-xl"
      style="font-size: 100px;"
    />
    <div class="text-h5 pc-bold text-grey-9 text-center q-mb-sm">
      {{ selectedPass.user }}
    </div>
    <div class="text-center q-mb-xl">
      <template v-if="!show">
        <q-icon name="fas fa-asterisk q-mx-xs" v-for="(ast, i) in 8" :key="i" />
      </template>
      <span class="text-h6" v-else>{{ selectedPass.password }}</span>
      <q-btn
        icon="content_copy"
        flat
        color="amber-6"
        round
        class="on-right"
        @click="copyToClipboard(selectedPass.password)"
      />
    </div>
    <div class="q-px-lg">
      <q-btn
        :label="show ? 'Hide password' : 'Show password'"
        rounded
        class="full-width pc-semibold q-mb-md q-py-xs"
        no-caps
        :icon="show ? 'visibility_off' : 'visibility'"
        color="indigo-6"
        unelevated
        push
        @click="show = !show"
      />
      <q-btn
        label="Edit password"
        rounded
        class="full-width pc-semibold q-mb-md q-py-xs"
        no-caps
        icon="edit"
        color="amber-6"
        unelevated
        push
      />
      <q-btn
        label="Delete password"
        rounded
        class="full-width pc-semibold q-py-xs"
        no-caps
        icon="delete_outline"
        color="red-6"
        unelevated
        push
        outline
        @click="deletePassword($route.params.passId)"
      />
    </div>
  </q-page>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      show: false,
      selectedPass: {},
    };
  },
  methods: {
    ...mapActions("appStore", ["deletePassword"]),

    copyToClipboard(text) {
      this.$clipboard(text);
      this.$q.notify({
        message: "Password copied!",
        color: "indigo-6",
        icon: "check",
        badgeColor: "amber-6",
        progress: true,
        classes: "pc-font pc-semibold higher-toast",
        timeout: 500,
      });
    },
  },
  computed: {
    ...mapState("appStore", ["userPasswords"]),
  },
  mounted() {
    // console.log(this.$route.params.passId);
    let pass = this.userPasswords.find(
      ({ id }) => id === this.$route.params.passId
    );
    // console.log(pass);
    this.selectedPass = pass;
  },
};
</script>
